import React, { Component } from 'react'
import { translate } from '../../utils/useful'

import DataMenu from './DataMenu'
import ToolsMenu from './ToolsMenu'
import ViewsMenu from './ViewsMenu'
import FrameSettingMenu from './FrameSettingMenu'
import SelectMenu from './SelectMenu'


export default class CollectionToolbar extends Component {

    state = {}

    componentDidMount() {
    }

    componentDidUpdate = (prevProps) => {
        // if (prevProps.data != this.props.data) { }
    }

    render() {

        // let colors = {
        //     primaryColor: '#fff',
        //     textColor: '#000',
        //     iconInvert: false,
        // }
        let colors = this.props.colors


        return (
            <div className='w-100 flexcb '>
                <div className='flex-1 flexc'>
                    <ViewsMenu permissions={this.props.permissions} colors={colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} />
                    <DataMenu permissions={this.props.permissions} colors={colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} setCurrentHead={this.props.setCurrentHead} hasFilter={this.props.hasFilter} hasSortedBy={this.props.hasSortedBy} sortedBy={this.props.sortedBy} hasGroupBy={this.props.hasGroupBy} />
                    <ToolsMenu permissions={this.props.permissions} colors={colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} />
                    <FrameSettingMenu permissions={this.props.permissions} colors={colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} />
                    {/* <SelectMenu permissions={this.props.permissions} colors={colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} /> */}

                    {this.props.showStack && (
                        <div className='flexcc' >
                            <button className='flexc  px-2  white' onClick={() => this.props.functionsHandler('collectionView', 'openSelectStack')} >
                                <div className='flexcc mrd-2 '>
                                    <img className={(!colors?.iconInvert ? 'invert' : '')} src="/assets/icons/useful/stack.png" height={'12px'} alt='' />
                                </div>
                                <p className='font-size-14 white ' style={{ color: colors?.textColor }}>{translate("Stack")}</p>
                            </button>
                        </div>
                    )}

                </div>

                <div className='flexc'>
                    <button className='flexc  px-2  white' onClick={() => this.props.functionsHandler('collectionView', 'openFilterView')} >
                        <div className='flexcc mrd-2 '>
                            <img className={(!colors?.iconInvert ? 'invert' : '')} src="/assets/icons/useful/search.png" height={'16px'} alt='' />
                        </div>
                        {/* <p className='font-size-14 white ' style={{ color: colors?.textColor }}>{translate("Stack")}</p> */}
                    </button>
                </div>
            </div>
        )
    }
}
